<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/RN1plZ/tc-custom/9781426867194.jpg?1706909082956" alt="This image is the cover for the book Italian's Passionate Proposal"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Italian's Passionate Proposal
      </h1>
      <p class="bookDescription body article font2">
        <b>Passion, drama, and undeniable chemistry heat up the holidays for a midwife and a sexy doctor with a secret in this romance by a <i>USA Today</i> bestseller.</b><br/><br/>Dark, handsome, and impossibly wealthy surgeon Carlo Santini can have any woman he wants. But working alongside nurse Suzannah Wilde at St. Catherine’s hospital, it’s hard for him to deny the sexual attraction simmering between them! Zan knows Carlo is holding something back from her, but all the same invites him to spend the festive season with her; only to discover that the caring baby doctor by day is a passionate, demanding lover by night. . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sarah Morgan
      </h2>
      
      <p class="authorDescription body article">Sarah Morgan is a USA Today and Sunday Times bestselling author of contemporary romance and women&#39;s fiction. She has sold more than 21 million copies of her books and her trademark humour and warmth have gained her fans across the globe. Sarah lives with her family near London, England, where the rain frequently keeps her trapped in her office. Visit her at www.sarahmorgan.com&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2a2a9fd6